import { Dialog } from '@/components/Dialog';
import { DialogContent } from '@/features/analyze/components/DownloadArticle/DialogContent';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  mounted: boolean;
  onClose: () => void;
};

export const DownloadArticleDialog = ({ isOpen, mounted, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => {}}
      title={t('CSVダウンロード')}
      maxWidth="md"
    >
      {mounted && <DialogContent isOpen={isOpen} onClose={onClose} />}
    </Dialog>
  );
};
